import type { TransactionReducer } from '@common/Checkout/Checkout/types/reducers';
import type { TransactionState } from '@common/Checkout/Checkout/types/transaction';
import {
    SET_TRANSACTION_PAYMENT_DATA,
    RESET_TRANSACTION,
    SET_IS_PROCESSING_TRANSACTION,
} from '../actions/constants';

const initialState: TransactionState = {
    payment: null,
    isProcessing: false,
};

// eslint-disable-next-line @typescript-eslint/default-param-last
const reducer: TransactionReducer = (state = initialState, action) => {
    const { type } = action;

    switch (type) {
        case SET_TRANSACTION_PAYMENT_DATA: {
            const { payload } = action;

            return { ...state, payment: payload.payment };
        }

        case SET_IS_PROCESSING_TRANSACTION: {
            const { payload } = action;
            return { ...state, isProcessing: payload };
        }

        case RESET_TRANSACTION: {
            return initialState;
        }

        default:
            return state;
    }
};

export default reducer;
